// Environment: client
import { StrictMode, type ComponentType } from 'react';
import { hydrateRoot, type Root } from 'react-dom/client';
import type { PageContextClient } from 'vike/types';
import { LazyMotion, domAnimation } from 'framer-motion';

import { Layout } from './Layout.js';
import { PageContextProvider, type AppPageContext } from './PageContextProvider.js';
import '~/styles/globals.css';

interface ClientPageContext {
  Page: ComponentType;
  urlPathname?: string;
}

let root: Root | null = null;

export function onRenderClient(pageContext: PageContextClient): void {
  const container = document.getElementById('page-root');
  if (!container) {
    throw new Error('Expected to find a <div id="page-root"> element to hydrate into.');
  }

  const { Page, urlPathname } = pageContext as unknown as ClientPageContext;
  const { locale, content } = pageContext;

  const app: AppPageContext = {
    locale,
    content,
    urlPathname: urlPathname ?? '/',
  };

  const tree = (
    <StrictMode>
      <LazyMotion features={domAnimation} strict>
        <PageContextProvider pageContext={app}>
          <Layout>
            <Page />
          </Layout>
        </PageContextProvider>
      </LazyMotion>
    </StrictMode>
  );

  if (root) {
    root.render(tree);
    return;
  }

  root = hydrateRoot(container, tree);
}
